import {Component, OnInit} from '@angular/core';
import {NavParams} from '@ionic/angular';
import {ApiResponseService} from 'src/app/services/api-response.service';
import {GlobalService} from 'src/app/services/global.service';

@Component({
    selector: 'app-verify-details-modal',
    templateUrl: './verify-details.modal.html',
})
export class VerifyDetailsModal implements OnInit {
    length = 4;
    disablePhoneSubmit = true;
    phoneOtp;
    disableEmailSubmit = true;
    emailOtp;
    phoneNumber;
    email;
    phoneVerified = false;
    emailVerified = false;
    changeType;
    constructor(private apiResponseService: ApiResponseService, public global: GlobalService, private navParams: NavParams) {
        this.phoneNumber = this.navParams.get('phoneNumber');
        this.email = this.navParams.get('email');
        this.changeType = this.navParams.get('changeType');
    }
    ngOnInit(): void {
        if (this.changeType === 'phone') {
            this.sendCodeToPhn();
        } else if (this.changeType === 'email') {
            this.sendCodeToEmail();
        } else {
            this.sendCodeToEmail();
            this.sendCodeToPhn();
        }
    }
    onPhoneOtpChange(event) {
        const otp = event.target.value;
        this.phoneOtp = otp;

        // Check if the OTP is of the correct length and numeric
        if (otp.length === this.length && /^\d+$/.test(otp)) {
            this.disablePhoneSubmit = false;
        } else {
            this.disablePhoneSubmit = true;
        }
    }
    onEmailOtpChange(event) {
        const otp = event.target.value;
        this.emailOtp = otp;

        // Check if the OTP is of the correct length and numeric
        if (otp.length === this.length && /^\d+$/.test(otp)) {
            this.disableEmailSubmit = false;
        } else {
            this.disableEmailSubmit = true;
        }
    }
    sendCodeToPhn() {
        this.apiResponseService.sendCodeToPhone(this.phoneNumber).subscribe((response) => {});
    }
    sendCodeToEmail() {
        this.apiResponseService.sendCodeToEmail(this.email).subscribe((response) => {});
    }
    onPhoneSubmit() {
        this.apiResponseService.verifyPhnNumber(this.global.isMobileApplication, this.phoneNumber, this.phoneOtp).subscribe((response) => {
            if (response.message === 'verification_success') {
                this.phoneVerified = true;
                this.global.basicAlert('Success', 'Verification successful');
                if (this.changeType === 'phone') {
                    this.global.closeModal({phoneVerified: true});
                } else if (this.changeType === 'both') {
                    if (this.emailVerified) {
                        this.global.closeModal({phoneVerified: true, emailVerified: true});
                    }
                }
            }
        });
    }
    onEmailSubmit() {
        this.apiResponseService.verifyEmailCode(this.email, this.emailOtp).subscribe((response) => {
            if (response.message === 'verification_successful') {
                this.emailVerified = true;
                this.global.basicAlert('Success', 'Verification successful');
                if (this.changeType === 'email') {
                    this.global.closeModal({phoneVerified: true});
                } else if (this.changeType === 'both') {
                    if (this.phoneVerified) {
                        this.global.closeModal({phoneVerified: true, emailVerified: true});
                    }
                }
            }
        });
    }

    closeModal() {}
}
